import React from 'react'
import styles from './styles.module.scss'
import { Item } from '@sitecore-jss/sitecore-jss-react'
import { slugify } from '../../../util/slugify'
import { TextField } from '../../../types/SitecoreAdapter'

export interface HeadingItem extends Item {
  fields: {
    title: TextField
    tocTitle?: TextField
  }
}

type TableOfContentsProps = {
  headings: HeadingItem[]
}

// Example offset (nav height + a little buffer)
const NAV_OFFSET = 200

const TableOfContents: React.FC<TableOfContentsProps> = ({ headings }) => {
  // Handler for the anchor clicks
  const handleLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    slug: string
  ) => {
    // Prevent normal anchor jump
    e.preventDefault()

    // If we're on the server, `window` won't be defined, so guard it:
    if (typeof window === 'undefined') return

    const targetElement = document.getElementById(slug)
    if (!targetElement) return

    // Get current scroll position plus the element’s distance from the top
    const elementPosition = targetElement.getBoundingClientRect().top
    const offsetPosition = window.scrollY + elementPosition - NAV_OFFSET

    // Smooth scroll to the calculated position
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })

    // Update the URL hash so it looks like we scrolled to #slug
    // but avoid the default “jump.”
    window.history.replaceState(null, '', `#${slug}`)
  }

  return (
    <div className={styles.tableOfContentsSection}>
      <div className="h3">Table of Contents</div>
      <ul>
        {headings?.map((heading) => {
          const tocTitle = heading.fields.tocTitle?.value?.trim()
          const displayTitle = tocTitle ? tocTitle : heading.fields.title.value
          const slug = slugify(displayTitle)
          
          return (
            <li key={heading.id}>
              {/* 
                Render normal anchor for SSR/SEO, 
                but intercept the click in the browser:
              */}
              <a href={`#${slug}`} onClick={(e) => handleLinkClick(e, slug)}>
                {displayTitle}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default TableOfContents
